module.exports = __webpack_public_path__ + "img/img-intro2@2x.e7154aa5.jpg";